// extracted by mini-css-extract-plugin
export default {"root":"Up_root__BI7Zy","show":"Up_show__uUPqJ"};